import React, {Component} from 'react'
import PropTypes from 'prop-types'
import RateGQL, { parseRateQueryResult } from './rate-gql'
import {RateScript} from './rate-script'
import EffectiveDate from './date-gql'

class Rate extends Component {
  static propTypes = {
    graphql: PropTypes.bool,
    rateType: PropTypes.string.isRequired,
    vertical: PropTypes.string,
    lenderSlug: PropTypes.string,
    term: PropTypes.number,
    variable: PropTypes.bool,
    name: PropTypes.string,
    decimals: PropTypes.number,
    append: PropTypes.string,
    prepend: PropTypes.string,
    label: PropTypes.element
  }

  static defaultProps = {
    graphql: false,
    decimals: 2,
    append: '%',
    prepend: ''
  }

  render() {
    const {graphql, ...props} = this.props

    if (graphql) {
      return <RateGQL {...props}/>
    } else {
      return <RateScript {...props}/>
    }
  }
}

export {Rate, EffectiveDate, parseRateQueryResult}
